export const CLIENT_CANCELABLE_ORDER_STATUSES = [
  "published",
  "awaitingoffer",
  "assigned",
  "assignedexecutor",
  "booked",
  "confirmed",
  "moderation",
  "rejected",
];

export const AVIATION_CANCELABLE_ORDER_STATUSES = [
  "awaitingoffer",
  "assigned",
  "moderation",
  "rejected",
  "confirmed",
];

const CLIENT_CANCELABLE_ORDER_STATUS_SET = new Set(CLIENT_CANCELABLE_ORDER_STATUSES);
const AVIATION_CANCELABLE_ORDER_STATUS_SET = new Set(AVIATION_CANCELABLE_ORDER_STATUSES);

export const canCancelSelectedOrders = (orders = [], isAirOrder = false) => {
  if (!orders.length) return false;

  const cancelableStatuses = isAirOrder
    ? AVIATION_CANCELABLE_ORDER_STATUS_SET
    : CLIENT_CANCELABLE_ORDER_STATUS_SET;

  return orders.every((order) => cancelableStatuses.has(order?.status));
};
